/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import Icon from '@material-ui/core/Icon';
import Carousel from '../../../../shared/patched-carousel';

import { withIdentifyList } from '../identify-list';

import classNames from 'classnames';

import { getSelectedArea } from '../../../../../selectors/map-selection';

import { openMobileMaxDetails } from '../../../../../actions/ui-actions';
import { setHighlight, clearHighlight, selectItem, closeAreaSelection } from '../../../../../actions/map-actions';

import styles from './mobile-identify.scss';

const CarouselIdentifyList = withIdentifyList(Carousel);

class MobileIdentify extends Component {
  constructor(props) {
    super(props);

    this.state = {
      entityIndex: 0,
      locationIndex: 0
    };
    this.setIdentifyHighlight = this.setIdentifyHighlight.bind(this);
    this.setSelectedIndex = this.setSelectedIndex.bind(this);
    this.back = this.back.bind(this);
    this.forward = this.forward.bind(this);
  }

  componentDidMount() {
    this.setIdentifyHighlight(this.state.entityIndex);
  }

  componentDidUpdate(prevProps) {
    if (this.props.parentId !== prevProps.parentId) {
      if (this.props.parentId) {
        this.setIdentifyHighlight(this.state.locationIndex);
      } else {
        this.setIdentifyHighlight(this.state.entityIndex);
      }
    }
    if (this.props.selectedArea !== prevProps.selectedArea) {
      this.resetIndexes();
    }
  }

  componentWillUnmount() {
    this.props.clearHighlight('identify');
    this.resetIndexes();
  }

  resetIndexes() {
    this.setState({entityIndex: 0, locationIndex: 0});
  }

  setIdentifyHighlight(index) {
    const { mapSelection, parentId } = this.props;
    if (!parentId) {
      const dataDetail = Object.entries(mapSelection)[index];
      const itemList = dataDetail[1].items;
      itemList.forEach(item => {
        this.props.setHighlight('identify', item.layerData.id, item.data.id);
      });
    } else {
      const dataDetail = mapSelection[parentId];
      const detail = dataDetail.items[index];
      const {layerData, data} = detail;
      this.props.setHighlight('identify', layerData.id, data.id);
    }
    if (this.props.onChange) {
      this.props.onChange(index);
    }
  }

  setSelectedIndex(index) {
    const { parentId } = this.props;
    this.props.clearHighlight('identify');
    if (parentId) {
      this.setState({locationIndex: index});
    } else {
      this.setState({entityIndex: index});
    }
    this.setIdentifyHighlight(index);
  }

  back() {
    const { parentId } = this.props;
    const { locationIndex, entityIndex } = this.state;
    const currentIndex = !parentId ? entityIndex : locationIndex;
    if (currentIndex > 0) {
      this.setSelectedIndex(currentIndex - 1);
    }
  }

  forward() {
    const { mapSelection, parentId } = this.props;
    const { locationIndex, entityIndex } = this.state;
    const dataCount = parentId ? mapSelection[parentId].items.length : Object.keys(mapSelection).length;
    const currentIndex = !parentId ? entityIndex : locationIndex;
    if (currentIndex < dataCount - 1) {
      this.setSelectedIndex(currentIndex + 1);
    }
  }

  render() {
    const { mapRef, mapSelection, parentId, setParentEntity } = this.props;
    const { locationIndex, entityIndex } = this.state;
    const dataCount = parentId ? mapSelection[parentId].items.length : Object.keys(mapSelection).length;
    const single = dataCount === 1;
    const currentIndex = !parentId ? entityIndex : locationIndex;
    return (
      <Fragment>
        <CarouselIdentifyList
          className={classNames(styles.identifyCarousel, {[styles.single]: single})}
          mapRef={mapRef}
          mapSelection={mapSelection}
          setParentEntity={setParentEntity}
          parentId={parentId}
          showThumbs={false}
          onClickItem={this.props.openMobileMaxDetails}
          onChange={this.setSelectedIndex}
          selectedItem={currentIndex}
          showIndicators={false}
          showArrows={false}
          showStatus
          emulateTouch
        />
        <Icon
          className={classNames(styles.button, styles.leftButton, {[styles.disabled]: currentIndex === 0})}
          onClick={currentIndex > 0 ? this.back : null}
        >
          keyboard_arrow_left
        </Icon>
        <Icon
          className={classNames(styles.button, styles.rightButton,
            {[styles.disabled]: currentIndex === dataCount - 1})}
          onClick={currentIndex < dataCount - 1 ? this.forward : null}
        >
          keyboard_arrow_right
        </Icon>
        <div className={styles.closeButton} onClick={this.props.closeAreaSelection}>CLOSE</div>
      </Fragment>

    );
  }
}

MobileIdentify.propTypes = {
  clearHighlight: PropTypes.func,
  closeAreaSelection: PropTypes.func,
  identifyIndex: PropTypes.number,
  mapRef: PropTypes.object.isRequired,
  mapSelection: PropTypes.object,
  onChange: PropTypes.func,
  openMobileMaxDetails: PropTypes.func,
  parentId: PropTypes.number,
  selectItem: PropTypes.func,
  selectedArea: PropTypes.object,
  setHighlight: PropTypes.func,
  setParentEntity: PropTypes.func
};

const mapStateToProps = state => ({
  selectedArea: getSelectedArea(state)
});

export default connect(
  mapStateToProps, {openMobileMaxDetails, setHighlight, clearHighlight, selectItem, closeAreaSelection}
)(MobileIdentify);
